import React from 'react';
import { Badge, Card } from '../../../components/app2';

/**
 * Datos de la cuenta (rediseño jul-2026).
 *
 * Mismos cuatro datos de siempre, con una corrección de fondo: "Miembro desde"
 * mostraba `loginTime` —la marca de tiempo del inicio de sesión ACTUAL—, así que
 * siempre decía "hoy". Ahora usa la fecha de alta real del usuario, que el API
 * de perfil ya expone; si no llega, se dice que no está disponible en vez de
 * inventar una fecha.
 */

const ACCOUNT_TYPE = {
  super_admin: 'Super Administrador',
  company_admin: 'Administrador de Empresa',
  employee: 'Empleado',
};

const fecha = (valor) => (valor ? new Date(valor)?.toLocaleDateString('es-MX', {
  day: '2-digit', month: 'long', year: 'numeric',
}) : null);

const Renglon = ({ label, children, ultimo = false }) => (
  <div
    style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 12, padding: '11px 0',
      borderBottom: ultimo ? 'none' : '1px solid var(--line)',
    }}
  >
    <span className="a2-tcell-muted">{label}</span>
    <span className="a2-tcell-strong" style={{ textAlign: 'right' }}>{children}</span>
  </div>
);

const AccountSettingsSection = ({ userData, profileData }) => {
  const perfil = profileData?.user || userData || {};
  const alta = fecha(perfil?.createdAt);
  const ultimoAcceso = fecha(perfil?.last_login ?? userData?.last_login);

  return (
    <Card>
      <h3 className="a2-card-title" style={{ fontSize: '1.1rem' }}>Datos de la cuenta</h3>
      <p className="a2-card-sub" style={{ marginBottom: 12 }}>
        Información que administra el sistema
      </p>

      <Renglon label="Tipo de cuenta">
        {ACCOUNT_TYPE[perfil?.user_type || userData?.user_type] || 'Usuario'}
      </Renglon>

      <Renglon label="Estado">
        <Badge
          tone={(perfil?.is_active ?? userData?.is_active) ? 'ok' : 'danger'}
          icon={(perfil?.is_active ?? userData?.is_active) ? 'check_circle' : 'cancel'}
        >
          {(perfil?.is_active ?? userData?.is_active) ? 'Activa' : 'Inactiva'}
        </Badge>
      </Renglon>

      <Renglon label="Miembro desde" ultimo={!ultimoAcceso}>
        {alta || <span className="a2-t-faint">No disponible</span>}
      </Renglon>

      {ultimoAcceso ? (
        <Renglon label="Último acceso" ultimo>{ultimoAcceso}</Renglon>
      ) : null}
    </Card>
  );
};

export default AccountSettingsSection;
